<script>
export default {
    props: {
        // 用来渲染的数据
        data: {
            type: Object,
            required: true,
        },
        // 一行的数据占据的空间 最多24
        span: {
            type: Number,
            default: 12,
        },
        // label宽度
        width: {
            type: String,
            default: '124px',
        },
        // 校验规则
        rules: {
            type: Object,
            default: () => ({}),
        },
        // form配置
        fields: {
            type: Array,
            required: true,
        },
        // 是否编辑状态
        type: {
            type: String,
            default: 'edit',
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        noMargin: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        getPropByPath(obj, path, strict) {
            let tempObj = obj;
            path = path.replace(/\[(\w+)\]/g, '.$1');
            path = path.replace(/^\./, '');

            const keyArr = path.split('.');
            let i = 0;
            for (let len = keyArr.length; i < len - 1; ++i) {
                if (!tempObj && !strict) break;
                const key = keyArr[i];
                if (key in tempObj) {
                    tempObj = tempObj[key];
                } else {
                    if (strict) {
                        throw new Error('please transfer a valid prop path to form item!');
                    }
                    break;
                }
            }
            return {
                o: tempObj,
                k: keyArr[i],
                v: tempObj ? tempObj[keyArr[i]] : null,
            };
        },
        renderItem(h, item) {
            const propValue = this.getPropByPath(this.data, item.prop || '');
            this.$set(propValue.o, propValue.k, propValue.v);
            if (item.template) {
                const {
                    render, tpl, attrs, events, ...config
                } = item.template;
                if (render && typeof render === 'function') {
                    return render(h, propValue.v, item, propValue, this.data);
                }
                return h(tpl, {
                    props: {
                        value: propValue.o[propValue.k],
                    },
                    attrs: {
                        ...attrs,
                    },
                    on: {
                        ...events,
                        input: (val) => {
                            propValue.o[propValue.k] = val;
                            if (events && events.input && typeof events.input === 'function') {
                                events.input(val);
                            }
                        },
                    },
                    ...config,
                });
            }
            if (item.slot) {
                return this.$slots[item.slot];
            }
            if (item.type === 'text') {
                let text = propValue.o[propValue.k];
                if (item.formatter && typeof item.formatter === 'function') {
                    text = item.formatter(text);
                }
                return <span>{text}</span>;
            }
            return <el-input v-model={propValue.o[propValue.k]} placeholder={`请输入${item.label}`} clearable={this.clearable} style={item.style} disabled={item.disabled}/>;
        },
        renderDetailItem(h, item) {
            const prop = item.detailProp || item.prop;
            const propValue = this.getPropByPath(this.data, prop || '');
            this.$set(propValue.o, propValue.k, propValue.v);
            if (item.detailTemplate) {
                const {
                    render, tpl, attrs, events, ...config
                } = item.detailTemplate;
                if (render && typeof render === 'function') {
                    return render(h, propValue.v, item, propValue, this.data);
                }
                return h(tpl, {
                    props: {
                        value: propValue.o[propValue.k],
                    },
                    attrs: {
                        ...attrs,
                    },
                    on: {
                        ...events,
                        input: (val) => {
                            propValue.o[propValue.k] = val;
                            if (events && events.input && typeof events.input === 'function') {
                                events.input(val);
                            }
                        },
                    },
                    ...config,
                });
            }
            if (item.slot) {
                return this.$slots[item.slot];
            }
            let text = propValue.o[propValue.k] == null || propValue.o[propValue.k] === ''
                ? '--'
                : propValue.o[propValue.k];
            if (item.formatter && typeof item.formatter === 'function') {
                text = item.formatter(text);
            }
            return <span>{item.emptyTemps && item.emptyTemps.includes(text) ? '--' : text}</span>;
        },
        getVM() {
            return this.$refs.goodsForm;
        },
    },
    render(h) {
        return (
            <xx-form
                ref="goodsForm"
                label-suffix="："
                label-width={this.width}
                props={{
                    model: this.data,
                    rules: this.rules,
                    disabled: this.disabled,
                }}
                validate-on-rule-change={false}
            >
                <el-row type="flex" style="flex-wrap: wrap">
                    {this.fields
                        .filter((item) => {
                            let visible = item.visible;
                            if (typeof item.visible === 'function') {
                                visible = item.visible(this.data);
                            }
                            return visible !== false;
                        })
                        .map((item, index) => (
                            <el-col span={item.span || this.span} key={item.prop || index}>
                                <xx-form-item
                                    class={{ 'no-margin': this.noMargin, 'is-required': item.required }}
                                    label={item.label}
                                    prop={item.prop}
                                    description={item.description}
                                >
                                    {this.type !== 'detail' || item.sameRender ? this.renderItem(h, item) : this.renderDetailItem(h, item)}
                                </xx-form-item>
                            </el-col>
                        ))}
                </el-row>
            </xx-form>
        );
    },
};
</script>
<style lang="scss" scoped>
.no-margin {
    margin-bottom: 0
}
</style>
